{
  "login": {
    "heading": "Logga in",
    "intro": "Den här journalen används när det centrala journalsystemet inte är tillgängligt. Logga in med ditt demokonto.",
    "username": "Användarnamn",
    "password": "Lösenord",
    "submit": "Logga in",
    "submitting": "Loggar in …",
    "missing": "Fyll i både användarnamn och lösenord."
  },
  "refusal": {
    "invalidCredentials": "Fel användarnamn eller lösenord.",
    "unknown": "Inloggningen nekades. Kontrollera användarnamn och lösenord och försök igen.",
    "unavailable": "Systemet svarar inte. Kontakta teknisk beredskap — skriv på papper under tiden.",
    "roleMayNotDocument": "Du är inloggad som {role} och kan läsa journalen men inte dokumentera i den."
  },
  "role": {
    "physician": "Läkare",
    "nurse": "Sjuksköterska"
  },
  "signedInAs": "{name} ({role})",
  "session": {
    "logout": "Logga ut",
    "expired": "Du har blivit utloggad. Logga in igen för att fortsätta."
  }
}
